import Text from 'components/shared/Text'
import { OpeningHoursDto } from 'store/api-slice/hooks'
import { OpeningHoursMobileWrapper } from 'components/shared/OpeningHours/components/styles'
import MobileOpeningHoursBox from './MobileOpeningHoursBox'
import { FormattedMessage } from 'react-intl'

interface OpeningHoursMobileProps {
    data: OpeningHoursDto[]
    hours: string[][]
}

const OpeningHoursMobile = ({ data, hours }: OpeningHoursMobileProps) => {
    if (!hours.length || !data.length) return <></>

    return (
        <OpeningHoursMobileWrapper direction="column" gap={16}>
            <Text variant="heading5" color="grayscale_900">
                <FormattedMessage
                    id="upsells.wellness.modal_spa_opening_hours_heading"
                    defaultMessage="Godziny otwarcia"
                />
            </Text>

            {data.map(({ rows, title }, index) => {
                if (!rows || !title || !hours[index].length) return null
                return (
                    <MobileOpeningHoursBox
                        key={`${title}${index}`}
                        rows={rows}
                        title={title}
                        hours={hours[index]}
                    />
                )
            })}
        </OpeningHoursMobileWrapper>
    )
}

export default OpeningHoursMobile
